document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;

  function getSwipeDirection(startX, startY, endX, endY) {
    const deltaX = endX - startX;
    const deltaY = endY - startY;
    const absDeltaX = Math.abs(deltaX);
    const absDeltaY = Math.abs(deltaY);

    if (absDeltaX > absDeltaY) {
      return deltaX > 0 ? "right" : "left"; // Horizontal swipe
    } else {
      return deltaY > 0 ? "down" : "up"; // Vertical swipe
    }
  }

  // Improved helper function to check if the touch event is inside a swiper
  function isTouchInSwiper(e) {
    // Check for various slider/swiper classes
    return e.target.closest('.swiper, .swiper-container, .bnz-footer-cards__swiper, .slider, [data-slider], [data-swiper], .slideshow, .product__media-list') !== null;
  }

  // All touch event variables declared together
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;
  let touchStartTime = 0;
  let lastTouchY = 0;
  let touchMoveY = 0;
  let touchVelocity = 0;
  let isScrolling = false;
  
  window.addEventListener(
    "touchstart",
    function (e) {
      // Skip if touch is in swiper
      if (isTouchInSwiper(e)) return;

      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      lastTouchY = touchStartY;
      touchStartTime = Date.now();
      touchVelocity = 0;
    },
    { passive: true }
  );
  
  window.addEventListener(
    "touchmove",
    function (e) {
      // Skip if touch is in swiper or during scrolling animation
      if (isTouchInSwiper(e) || isScrolling) return;

      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
      touchMoveY = touchEndY;

      const now = Date.now();
      const dt = now - touchStartTime;

      if (dt > 0) {
        touchVelocity = (touchEndY - lastTouchY) / dt;
        lastTouchY = touchEndY;
        touchStartTime = now;
      }

      // Get the swipe direction
      const direction = getSwipeDirection(touchStartX, touchStartY, touchEndX, touchEndY);
      
      // Only prevent default for vertical swipes when not in a slider
      if ((direction === "up" || direction === "down") &&
          ((touchStartY > touchEndY && currentSection < sections.length - 1) ||
          (touchStartY < touchEndY && currentSection > 0))) {
        e.preventDefault();
      }
    },
    { passive: false }
  );


  window.addEventListener(
    "touchend",
    function (e) {
      // Skip if touch is in swiper or during scrolling animation
      if (isTouchInSwiper(e) || isScrolling) return;

      touchEndX = e.changedTouches[0].clientX;
      touchEndY = e.changedTouches[0].clientY;

      const diffX = touchStartX - touchEndX;
      const diffY = touchStartY - touchEndY;
      const timeDiff = Date.now() - touchStartTime;

      const direction = getSwipeDirection(touchStartX, touchStartY, touchEndX, touchEndY);
      const isQuickFlick = Math.abs(touchVelocity) > 0.5;

      // Handle vertical swipes only
      if (direction === "up" || direction === "down") {
        if (Math.abs(diffY) > 50 || (Math.abs(diffY) > 15 && timeDiff < 300) || isQuickFlick) {
          if ((diffY > 0 || touchVelocity < -0.5) && currentSection < sections.length - 1) {
            goToSection(currentSection + 1);
          } else if ((diffY < 0 || touchVelocity > 0.5) && currentSection > 0) {
            goToSection(currentSection - 1);
          }
        }
      }
    },
    { passive: false }
  );

  // Special handling for contact page
  if (currentPath === '/pages/contact-1' || currentPath === '/pages/about') {
    // Hide footer on contact page
    const footer = document.getElementById("shopify-section-sections--24910956495193__footer");
    if (footer) {
      footer.style.display = "none";
    }

    // Also hide any footer cards section if it exists
    const footerCards = document.getElementById("shopify-section-sections--24910956495193__bnz_footer_cards_b7QQHA");
    if (footerCards) {
      footerCards.style.display = "none";
    }

    // Don't apply custom scrolling to the contact page
    return;
  }

  // Target ALL shopify sections that should be included in the scroll
  const mainContent = document.getElementById("MainContent");
  if (!mainContent) return;

  // Select any shopify-section that should be included
  const mainContentSections = Array.from(
    mainContent.querySelectorAll(
      ".shopify-section.section, " +
        "#shopify-section-sections--24910956495193__footer, " +
        "#shopify-section-template--24910956036441__bnz_footer_cards_FL4ehM, " +
        "#shopify-section-template--24910956036441__image_banner_7KFzeG"
    )
  );

    // Separately find the footer section that's outside MainContent
    const footerSection = document.getElementById("shopify-section-sections--24910956495193__footer");

    // Combine all sections into one array
    const sections = [...mainContentSections];
    if (footerSection) {
      sections.push(footerSection);
    }
  
    if (sections.length === 0) return;

  // Add the section class to any that don't have it (for styling)
  sections.forEach((section) => {
    if (!section.classList.contains("section")) {
      section.classList.add("section");
    }
  });
  
  // Variables for scroll handling - moved up for better organization
  let currentSection = 0;
  let lastScrollTime = Date.now();
  let scrollTimeout;
  let scrollDirection = null;

  // Configuration: Map section indices to background colors
  const sectionColors = {
    0: "white",
    1: "white",
    2: "white",
    3: "white",
    4: "white",
    5: "white",
    6: "white",
    7: "white",
    8: "white",
  };

  let darkHeaderSections;
  // Page-specific configurations
  if (currentPath === '/pages/le-book') {
    darkHeaderSections = [0,3, 4];
  } else if (currentPath === '/pages/tres-confidentiel-le-salon') {
    darkHeaderSections = [0,1, 2, 3];
  } else if (currentPath === '/pages/contact-1') {
    darkHeaderSections = [0,1,2];
  } else if (currentPath === '/pages/mode-demploi') {
    darkHeaderSections = [0,1,2];
  } else if (currentPath === '/pages/about') {
    darkHeaderSections = [0];
  } else {
    darkHeaderSections = [1, 2, 3, 5, 6, 7];
  }

  // Create/find container with proper styling for smooth transitions
  let container = mainContent.querySelector(".sections-container");
  if (!container) {
    container = document.createElement("div");
    container.className = "sections-container";
    
    // Apply container styling for better perspective
    container.style.position = "fixed";
    container.style.top = "0";
    container.style.left = "0";
    container.style.width = "100%";
    container.style.height = "100vh";
    container.style.overflow = "hidden";
    container.style.perspective = "1200px";
    
    // Move sections into container in the right order
    sections.forEach((section) => {
      if (section.parentNode !== container) {
        const originalParent = section.parentNode;
        if (originalParent) {
          originalParent.removeChild(section);
        }
        container.appendChild(section);
        
        // Enhanced styling with FASTER transitions (0.3s instead of 0.5s)
        section.style.position = "absolute";
        section.style.width = "100%";
        section.style.height = "100%";
        section.style.overflow = "hidden";
        section.style.transition = "transform 0.8s cubic-bezier(0.645, 0.045, 0.355, 1.000)"; // Removed opacity transition
        section.style.backfaceVisibility = "hidden";
        section.style.willChange = "transform";
      }
    });

    mainContent.appendChild(container);
    
    // Add spacer div to maintain page length
    const spacer = document.createElement("div");
    spacer.style.height = "100vh";
    mainContent.appendChild(spacer);
  }

  // Special handling for footer cards section
  const footerCardsSection = document.getElementById('shopify-section-sections--24910956495193__bnz_footer_cards_b7QQHA');
  if (footerCardsSection) {
    // Ensure the footer cards section has proper styling
    const cardsContainer = footerCardsSection.querySelector('.bnz-footer-cards');
    if (cardsContainer) {
      cardsContainer.style.height = "100%";
      cardsContainer.style.display = "flex";
      cardsContainer.style.flexDirection = "column";
      cardsContainer.style.alignItems = "center";
      cardsContainer.style.justifyContent = "center";
      cardsContainer.style.padding = "50px 0";
      cardsContainer.style.boxSizing = "border-box";
      cardsContainer.style.backgroundColor = "#111";
    }
    
    // Enhance card styling for better visibility in card mode
    const cards = footerCardsSection.querySelectorAll('.bnz-footer-cards__card');
    cards.forEach(card => {
      card.style.backgroundColor = "rgba(30, 30, 30, 0.8)";
      card.style.borderRadius = "10px";
      card.style.padding = "20px";
      card.style.boxShadow = "0 10px 20px rgba(0,0,0,0.15)";
      card.style.margin = "10px";
      card.style.transform = "translateZ(0)"; // Hardware acceleration
    });
    
    // Make all text in cards white
    const cardTitles = footerCardsSection.querySelectorAll('.bnz-footer-cards__title');
    cardTitles.forEach(title => {
      title.style.color = "#fff";
    });
  }

  // Create section indicators (dots)
  const indicators = document.createElement("div");
  indicators.className = "section-indicators";
  indicators.style.position = "fixed";
  indicators.style.right = "20px";
  indicators.style.top = "50%";
  indicators.style.transform = "translateY(-50%)";
  indicators.style.zIndex = "100";
  indicators.style.display = "flex";
  indicators.style.flexDirection = "column";
  indicators.style.gap = "12px";
  
  sections.forEach((_, i) => {
    const dot = document.createElement("div");
    dot.className = "section-indicator";
    dot.style.width = "8px";
    dot.style.height = "8px";
    dot.style.borderRadius = "50%";
    dot.style.backgroundColor = "#888";
    dot.style.cursor = "pointer";
    dot.style.transition = "all 0.3s ease";
    dot.addEventListener("click", () => goToSection(i));
    indicators.appendChild(dot);
  });
  document.body.appendChild(indicators);

  // Create chevron navigation with enhanced styling
  const chevronNav = document.createElement("div");
  chevronNav.className = "chevron-nav";
  chevronNav.style.position = "fixed";
  chevronNav.style.bottom = "20px";
  chevronNav.style.left = "50%";
  chevronNav.style.transform = "translateX(-50%)";
  chevronNav.style.zIndex = "100";
  chevronNav.style.display = "flex";
  chevronNav.style.gap = "10px";
  document.body.appendChild(chevronNav);

  // Create the chevron element with enhanced styling
  const upChevron = document.createElement("div");
  upChevron.className = "chevron chevron-up";
  upChevron.style.width = "20px";
  upChevron.style.height = "20px";
  upChevron.style.display = "flex";
  upChevron.style.alignItems = "center";
  upChevron.style.justifyContent = "center";
  upChevron.style.borderRadius = "50%";
  upChevron.style.backgroundColor = "rgba(255,255,255,0.2)";
  upChevron.style.backdropFilter = "blur(5px)";
  upChevron.style.cursor = "pointer";
  upChevron.style.transition = "opacity 0.3s ease, background-color 0.3s ease";
  upChevron.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z" fill="currentColor"/></svg>';
  upChevron.addEventListener("click", function () {
    if (currentSection > 0) {
      goToSection(currentSection - 1);
    }
  });
  chevronNav.appendChild(upChevron);

  const downChevron = document.createElement("div");
  downChevron.className = "chevron chevron-down";
  downChevron.style.width = "20px";
  downChevron.style.height = "20px";
  downChevron.style.display = "flex";
  downChevron.style.alignItems = "center";
  downChevron.style.justifyContent = "center";
  downChevron.style.borderRadius = "50%";
  downChevron.style.backgroundColor = "rgba(255,255,255,0.2)";
  downChevron.style.backdropFilter = "blur(5px)";
  downChevron.style.cursor = "pointer";
  downChevron.style.transition = "opacity 0.3s ease, background-color 0.3s ease";
  downChevron.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" fill="currentColor"/></svg>';
  downChevron.addEventListener("click", function () {
    if (currentSection < sections.length - 1) {
      goToSection(currentSection + 1);
    }
  });
  chevronNav.appendChild(downChevron);

  // Update function for indicator dots
  function updateIndicators(index) {
    const dots = indicators.querySelectorAll('.section-indicator');
    dots.forEach((dot, i) => {
      if (i === index) {
        dot.style.backgroundColor = "#fff";
        dot.style.boxShadow = "0 0 10px rgba(255,255,255,0.7)";
        dot.style.transform = "scale(1.3)";
      } else {
        dot.style.backgroundColor = "#888";
        dot.style.boxShadow = "none";
        dot.style.transform = "scale(1)";
      }
    });
  }

  // Function to update chevron direction with animation
  function updateChevronVisibility(index) {
    // Hide up chevron on first section
    upChevron.style.opacity = index === 0 ? "0.3" : "1";
    upChevron.style.pointerEvents = index === 0 ? "none" : "auto";
    
    // Hide down chevron on last section
    downChevron.style.opacity = index === sections.length - 1 ? "0.3" : "1";
    downChevron.style.pointerEvents = index === sections.length - 1 ? "none" : "auto";
  }

  // Initialize positions with enhanced initial state
  sections.forEach((section, i) => {
    if (i < currentSection) {
      section.style.transform = "translate3d(0, -100%, 0)";
      section.style.opacity = "1"; // Changed from 0 to 1
    } else if (i > currentSection) {
      section.style.transform = "translate3d(0, 100%, 0)";
      section.style.opacity = "1"; // Changed from 0 to 1
    } else {
      section.style.transform = "translate3d(0, 0, 0) scale(1)";
      section.style.opacity = "1";
    }

    // Set initial z-index (current section on top)
    section.style.zIndex = i === currentSection ? 3 : 1;
  });

  // Apply initial states
  applyBackgroundColor(currentSection);
  updateHeaderColors(currentSection);
  updateChevronVisibility(currentSection);
  updateIndicators(currentSection);

  // Function to apply background color to sections with smoother transitions
  function applyBackgroundColor(index) {
    const section = sections[index];
    if (!section) return;

    const color = sectionColors[index] || "#ffffff";

    // Find and apply to gradient elements within section
    const gradients = section.querySelectorAll(".gradient");
    if (gradients.length > 0) {
      gradients.forEach((el) => {
        el.style.backgroundColor = color;
        el.style.transition = "background-color 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000)";
      });
    } else {
      // If no gradients, apply directly to section
      section.style.backgroundColor = color;
      section.style.transition = "background-color 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000)";
    }
  }

  // Function to update header text colors with smoother transitions
  function updateHeaderColors(index) {
    // Get header elements
    const headerMenuItems = document.querySelectorAll(
      ".header__menu-item span"
    );
    const headerIcons = document.querySelectorAll(".header__icon svg");
    const headerLogo = document.querySelector(".header__heading-logo");
    // Check if current section needs dark text (light background)
    const isDarkTextSection = darkHeaderSections.includes(index);
    const textColor = isDarkTextSection ? "#000000" : "#ffffff";
    
    // Apply to menu items with improved transitions
    headerMenuItems.forEach((item) => {
      item.style.color = textColor;
      item.style.transition = "color 0.4s cubic-bezier(0.645, 0.045, 0.355, 1.000)";
    });
    
    // Apply gradient style to header menu items' :after pseudo-element
    const styleElement = document.getElementById('header-menu-styles') || document.createElement('style');
    if (!styleElement.id) styleElement.id = 'header-menu-styles';
    
    // Set appropriate gradient based on section type
    if (isDarkTextSection) {
      styleElement.textContent = `
        .header__menu-item:after {
          background: linear-gradient(to right, transparent, rgb(0 0 0 / 80%), transparent);
          transition: width .3s ease, left .3s ease;
        }
      `;
    } else {
      styleElement.textContent = `
        .header__menu-item:after {
          background: linear-gradient(to right, transparent, rgb(255 255 255 / 80%), transparent);
          transition: width .3s ease, left .3s ease;
        }
      `;
    }
    
    if (!styleElement.parentNode) {
      document.head.appendChild(styleElement);
    }
    
    // Apply to icons with improved transitions
    headerIcons.forEach((icon) => {
      icon.style.color = textColor;
      icon.style.fill = textColor;
      icon.style.transition = "color 0.4s cubic-bezier(0.645, 0.045, 0.355, 1.000), fill 0.4s cubic-bezier(0.645, 0.045, 0.355, 1.000)";
    });
    
    // Apply to logo if needed with improved transitions
    if (headerLogo) {
      headerLogo.style.filter = isDarkTextSection ? "invert(0)" : "invert(1)";
      headerLogo.style.transition = "filter 0.4s cubic-bezier(0.645, 0.045, 0.355, 1.000)";
    }
  }

  // Enhanced wheel event handling with adaptive sensitivity
  window.addEventListener(
    "wheel",
    function (e) {
      // Skip wheel events inside sliders/swipers
      if (isTouchInSwiper(e)) return;
      
      e.preventDefault();

      if (isScrolling) return;

      const now = Date.now();
      const timeSinceLastScroll = now - lastScrollTime;
      const scrollSpeed = Math.abs(e.deltaY) / timeSinceLastScroll;
      
      // Determine direction for momentum scrolling
      const newDirection = e.deltaY > 0 ? 'down' : 'up';
      if (scrollDirection !== newDirection) {
        scrollDirection = newDirection;
      }

      // Clear any existing timeout
      clearTimeout(scrollTimeout);
      
      // Set a dynamic timeout based on scroll speed - faster response
      const timeoutDuration = scrollSpeed > 0.5 ? 20 : 40;
      
      scrollTimeout = setTimeout(() => {
        if (e.deltaY > 20 && currentSection < sections.length - 1) {
          // Scroll down
          goToSection(currentSection + 1);
        } else if (e.deltaY < -20 && currentSection > 0) {
          // Scroll up
          goToSection(currentSection - 1);
        }
      }, timeoutDuration);
      
      lastScrollTime = now;
    },
    { passive: false }
  );

  // Removed duplicate touchstart/touchmove/touchend listeners

  // Enhanced keyboard navigation
  window.addEventListener("keydown", function (e) {
    if (isScrolling) return;

    // Skip keyboard navigation if focus is in an input, textarea, or slider control
    if (document.activeElement && 
        (document.activeElement.tagName === 'INPUT' || 
         document.activeElement.tagName === 'TEXTAREA' ||
         document.activeElement.closest('.swiper, .slider'))) {
      return;
    }

    if (
      (e.key === "ArrowDown" || e.key === "PageDown" || e.key === " ") &&
      currentSection < sections.length - 1
    ) {
      e.preventDefault();
      goToSection(currentSection + 1);
    } else if (
      (e.key === "ArrowUp" || e.key === "PageUp") &&
      currentSection > 0
    ) {
      e.preventDefault();
      goToSection(currentSection - 1);
    } else if (e.key === "Home") {
      e.preventDefault();
      goToSection(0);
    } else if (e.key === "End") {
      e.preventDefault();
      goToSection(sections.length - 1);
    }
  });
  
  // Enhanced section transition with advanced animations
  function goToSection(index) {
    if (isScrolling || index < 0 || index >= sections.length) return;
    
    isScrolling = true; // Set flag properly at start of transition
    
    const direction = index > currentSection ? "down" : "up";
    const prev = currentSection;
    currentSection = index;
    updateChevronVisibility(index);
    updateIndicators(index);
  
    const STACK_OFFSET = 20; // px per depth
  
    sections.forEach((section, i) => {
      // fully hide cards not in the active stack
      const inStackDown = direction === "down" && i < currentSection;
      const inStackUp   = direction === "up"   && i > currentSection;
      const isCurrent   = i === currentSection;
  
      section.style.visibility = (isCurrent || inStackDown || inStackUp)
        ? "visible" 
        : "hidden";
  
      if (isCurrent) {
        section.style.transform = "translate3d(0,0,0)";
        section.style.zIndex = sections.length;
        section.style.boxShadow = direction==="down"
          ? "0 -5px 20px rgba(0,0,0,0.15)"
          : "0 5px 20px rgba(0,0,0,0.15)";
      }
      else if (direction === "down" && inStackDown) {
        const depth = currentSection - i;
        section.style.transform = `translate3d(0, -${STACK_OFFSET * depth}px, 0)`;
        section.style.zIndex = sections.length - depth;
        section.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
      }
      else if (direction === "up" && inStackUp) {
        const depth = i - currentSection;
        section.style.transform = `translate3d(0, ${STACK_OFFSET * depth}px, 0)`;
        section.style.zIndex = sections.length - depth;
        section.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
      }
      else {
        // slide completely off
        const offY = direction === "down" ? "100%" : "-100%";
        section.style.transform = `translate3d(0, ${offY}, 0)`;
        section.style.zIndex = 0;
        section.style.boxShadow = "none";
      }
    });
  
    applyBackgroundColor(index);
    updateHeaderColors(index);
    
    // Match this timeout to your transition duration (0.8s)
    setTimeout(() => {
      isScrolling = false;
    }, 800);
  }

  // Debug helper function (uncomment if needed)
  /*
  function debugTouchTarget(e) {
    const target = e.target;
    const isSwiper = isTouchInSwiper(e);
    console.log('Touch target:', target, 'Is in swiper:', isSwiper);
    
    // List all parent elements up to body
    let element = target;
    const path = [];
    while (element && element !== document.body) {
      path.push({
        element: element,
        classes: element.className,
      });
      element = element.parentElement;
    }
    console.log('Element path:', path);
  }
  */

  // Public method to allow external control
  window.goToSection = goToSection;
});